import { useSelector } from 'react-redux';
import { isAuthenticatedSelector } from '../../features/auth/selector.auth';

const useIsAuthenticated = (): boolean => {
  return useSelector(isAuthenticatedSelector);
};

export default useIsAuthenticated;
